export const internationalConfig = {
    fpAttributes: [],
    get schema() {
        return {
            title: 'Global',
            type: 'array',
            items: {
                title: 'Module',
                type: 'object',
                properties: {
                    id: {
                        title: 'ID',
                        type: 'string',
                    },
                    title: {
                        title: 'Title',
                        type: 'string',
                    },
                    description: {
                        title: 'Description',
                        type: 'string',
                        format: 'textarea',
                    },
                    rank: {
                        title: 'Rank',
                        type: 'integer',
                    },
                    label: {
                        title: 'Module Label',
                        type: 'string',
                    },
                    iconLabel: {
                        title: 'Icon Label',
                        type: 'string',
                    },
                    featuredMedia: {
                        title: 'Featured Media',
                        type: 'object',
                        properties: {
                            file: {
                                title: 'Image File',
                                type: 'string',
                            },
                            caption: {
                                title: 'Image Caption',
                                type: 'string',
                            },
                            title: {
                                title: 'Image Title',
                                type: 'string',
                            },
                        },
                    },
                    courses: {
                        title: 'Courses',
                        type: 'array',
                        items: {
                            title: 'Course',
                            type: 'object',
                            properties: {
                                id: {
                                    title: 'ID',
                                    type: 'string',
                                },
                                title: {
                                    title: 'Title',
                                    type: 'string',
                                },
                                type: {
                                    title: 'Type',
                                    type: 'string',
                                },
                                courseNumber: {
                                    title: 'Course Number',
                                    type: 'integer',
                                },
                                courseTotal: {
                                    title: 'Course Total',
                                    type: 'integer',
                                },
                                timeToRead: {
                                    title: 'Time to Read',
                                    type: 'integer',
                                },
                                videoId: {
                                    title: 'Video ID',
                                    type: 'string',
                                },
                                videoService: {
                                    title: 'Video Service',
                                    type: 'string',
                                },
                                description: {
                                    title: 'Description',
                                    type: 'string',
                                    format: 'textarea',
                                },
                                facilitator: {
                                    title: 'Facilitator',
                                    type: 'string',
                                },
                                facilitatorMeta: {
                                    title: 'Facilitator Info',
                                    type: 'object',
                                    properties: {
                                        firstName: {
                                            title: 'First Name',
                                            type: 'string',
                                        },
                                        lastName: {
                                            title: 'Last Name',
                                            type: 'string',
                                        },
                                        description: {
                                            title: 'Description',
                                            type: 'string',
                                        },
                                        designation: {
                                            title: 'Designation',
                                            type: 'string',
                                        },
                                        location: {
                                            title: 'Location',
                                            type: 'string',
                                        },
                                        linkedin: {
                                            title: 'Linkedin',
                                            type: 'string',
                                        },
                                        twitter: {
                                            title: 'Twitter',
                                            type: 'string',
                                        },
                                        image: {
                                            title: 'Image',
                                            type: 'string',
                                        },
                                    },
                                },
                                thumbnailImage: {
                                    title: 'Thumbnail Image',
                                    type: 'object',
                                    properties: {
                                        file: {
                                            title: 'File',
                                            type: 'string',
                                        },
                                        caption: {
                                            title: 'Caption',
                                            type: 'string',
                                        },
                                        title: {
                                            title: 'Title',
                                            type: 'string',
                                        },
                                    },
                                },
                                headerImage: {
                                    title: 'Header Image',
                                    type: 'object',
                                    properties: {
                                        file: {
                                            title: 'File',
                                            type: 'string',
                                        },
                                        caption: {
                                            title: 'Caption',
                                            type: 'string',
                                        },
                                        title: {
                                            title: 'Title',
                                            type: 'string',
                                        },
                                    },
                                },
                                curriculum: {
                                    title: 'Curriculum',
                                    type: 'array',
                                    items: {
                                        title: 'Curriculum Item',
                                        type: 'object',
                                        properties: {
                                            id: {
                                                title: 'ID',
                                                type: 'string',
                                            },
                                            title: {
                                                title: 'Title',
                                                type: 'string',
                                            },
                                            slug: {
                                                title: 'Slug',
                                                type: 'string',
                                            },
                                            link: {
                                                title: 'Link (set if resource is an external link)',
                                                type: 'string',
                                            },
                                            type: {
                                                title: 'Type',
                                                type: 'string',
                                            },
                                            required: {
                                                title: 'Required',
                                                type: 'string',
                                                enum: ['true', 'false'],
                                            },
                                            timeToRead: {
                                                title: 'Time to Read',
                                                type: 'integer',
                                            },
                                            conditions: {
                                                title: 'Conditons',
                                                type: 'array',
                                                items: {
                                                    title: 'Condition',
                                                    type: 'object',
                                                    properties: {
                                                        financialPortraitPath: {
                                                            title: 'FP Answer Equals',
                                                            type: 'string',
                                                            enum: this.fpAttributes,
                                                        },
                                                        conditionToApply: {
                                                            title: 'Condition To Apply',
                                                            type: 'string',
                                                            enum: ['optional', 'required', 'include', 'hidden'],
                                                        },
                                                    },
                                                },
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        };
    },
};
//# sourceMappingURL=internationalConfig.js.map